import { combineReducers } from "redux";
import accountListReducer from "./account_list_reducer";
import accountUsersReducer from "./account_users_reducer";
import walletReducer from "./account_wallet_reducer";
import accountCampaignPricingEmailReducer from "./account_campaign_pricing_email_reducer";
import accountCampaignPricingSmsReducer from "./account_campaign_pricing_sms_reducer";
import accountCampaignPricingWhatsappReducer from "./account_campaign_pricing_whatsapp_reducer";
import accountCampaignPricingEmailFinderReducer from "./account_campaign_pricing_email_finder_reducer";
import accountCampaignPricingEmailValidationReducer from "./account_campaign_pricing_email_validation_reducer";
import accountCampaignReducer from "./account_campaign_reducer";
import accountLoginSessionsReducer from "./account_login_session_reducer";
import accountSettingsReducer from "./account_settings_reducer";
import accountCampaignPricingWhatsapp2Reducer from "./account_campaign_pricing_whatsapp_2_reducer.js";
import rcsBotConfigurationReducer from './account_campaign_rcs_bot_config_reducer.js';
import accountCampaignPricingRCSReducer from "./account_campaign_pricing_rcs_reducer.js";
import accountCampaignSummaryReducer from "./account_campaign_summary_reducer.js";

const accountReducer = combineReducers({
  allAccounts: accountListReducer,
  accountUsers: accountUsersReducer,
  accountWallet: walletReducer,
  accountCampaignPricingEmail: accountCampaignPricingEmailReducer,
  accountCampaignPricingSms: accountCampaignPricingSmsReducer,
  accountCampaignPricingWhatsapp2: accountCampaignPricingWhatsapp2Reducer,
  accountCampaignPricingWhatsapp: accountCampaignPricingWhatsappReducer,
  accountCampaignPricingRCS: accountCampaignPricingRCSReducer,
  accountCampaignPricingEmailFinder: accountCampaignPricingEmailFinderReducer,
  accountCampaignPricingEmailValidation: accountCampaignPricingEmailValidationReducer,
  campaign: accountCampaignReducer,
  sessions: accountLoginSessionsReducer,
  settings: accountSettingsReducer,
  accountRcsBotConfig: rcsBotConfigurationReducer,
  summary: accountCampaignSummaryReducer
});

export default accountReducer;
